import axios from 'axios';
import { SellerOrder, SellerOrderStatus, OrderSummary } from '../types/order.types';

const BASE = process.env.REACT_APP_API_URL;
const auth = (token: string) => ({ headers: { Authorization: `Bearer ${token}` } });

export interface SellerOrderListResponse {
    orders:       SellerOrder[];
    total:        number;
    page:         number;
    pages:        number;
    summary:      OrderSummary;
    totalRevenue: number;
}

export const sellerOrderService = {

    getOrders: (params: Record<string, any>, token: string) =>
        axios.get<SellerOrderListResponse>(`${BASE}/seller/orders`, { ...auth(token), params }),

    getOrderById: (id: string, token: string) =>
        axios.get<{ order: SellerOrder }>(`${BASE}/seller/orders/${id}`, auth(token)),

    updateStatus: (id: string, status: SellerOrderStatus, token: string) =>
        axios.patch<{ order: SellerOrder }>(`${BASE}/seller/orders/${id}/status`, { status }, auth(token)),
};
